import Navbar from "./navbar/Navbar";
import Hero from "./hero/Hero";

function HeroSection() {
  return (
    <div className="relative" id="home">
      <Navbar isHomePage={true} />
      <Hero />
    </div>
  );
}

export default HeroSection;
